import styled from 'styled-components'

import { CustomButton } from '../../../../styles/global'
import { CardContainer, CardSkeleton } from '../../../../components/Card/styles'

export const Container = styled.div`
  width:100%;
  padding: 1rem;
  margin:0 auto;
`

export const Button = styled(CustomButton)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
  border: none;
  width: 90px;

  svg {
    height: 12px;
    width: 12px;
  }
`

export const StyledCard = styled.div`
  display: flex;
  height: 100%;

  ${CardContainer}{
    box-sizing: border-box;
    align-items: flex-start;
    width: 100%;
    border: 1px solid #DADADA;
    box-shadow: none;
  }
  ${CardSkeleton}{
    width: 100%;
    min-height: 99px;
  }
  ${CardSkeleton}:first-child {
    min-height: 137px;
  }
`

export const CategoryRow = styled.div`
  width: 100%;
`

export const Category = styled.h2`
  padding: 2px 8px 3px;
  border-radius: 8px;
  ${props => props.backgroundColor ? `background-color: ${props.backgroundColor};` : 'background-color: #E0F8F9;'}
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
  ${props => props.color ? `color: ${props.color};` : 'color: #01878E;'}
  margin-bottom: 0;
  width: fit-content;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  max-width: 100%;
`

export const Subtitle = styled.h2`
  color: #000;
  font-family: 'Nunito';
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  overflow: hidden;
`

export const Text = styled.p`
  color: #555;
  white-space: pre-wrap;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  ${props => props.hasMargin && 'margin-left: 8px'};
  margin-bottom: 0px;

  strong {
    font-family: 'Open Sans';
    color: #01878E;
    font-weight: 600;
  }
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
